module.exports = __webpack_public_path__ + "static/equipment-forklift-7551cd60a9aae80b722715fd669baf5a.jpg";